import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "last-seen-hotel" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "last-seen-hotel__image-wrapper" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "last-seen-hotel__info" }
const _hoisted_6 = { class: "last-seen-hotel__heading" }
const _hoisted_7 = { class: "last-seen-hotel__region" }

import HotelStars from '@lmt-rpb/HotelStars/HotelStars.vue';

interface Props {
	title: string
	image: string,
	url: string,
	region: string,
	hotelRating: number,
	showSuns: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LastSeenHotelItem',
  props: {
    title: {},
    image: {},
    url: {},
    region: {},
    hotelRating: {},
    showSuns: { type: Boolean }
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("a", {
      class: "last-seen-hotel__link",
      href: _ctx.url,
      rel: "nofollow"
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "last-seen-hotel__img",
          src: _ctx.image,
          alt: _ctx.title
        }, null, 8 /* PROPS */, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.title), 1 /* TEXT */),
        _createVNode(HotelStars, {
          class: "last-seen-hotel__rating",
          rating: _ctx.hotelRating,
          "hotel-box": false,
          "show-suns": _ctx.showSuns
        }, null, 8 /* PROPS */, ["rating", "show-suns"]),
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.region), 1 /* TEXT */)
      ])
    ], 8 /* PROPS */, _hoisted_2)
  ]))
}
}

})